
$(function () {
    yieldInvestmentReturns = {
        endpoint: '/Main/YieldInvestmentReturnsBlock/GetYieldInvestmentReturnData',
        tableData: {},
        tableHeaderArray: [],
        tableClassesArray: [],
        tableTitleArray: [],
        retrieved: false,
        wrapperDiv: $('#veYieldInvestmentReturns'),
        isExcelDownloading: false,
        toggleEventListenersAdded: false,
        blockId: $('#veYieldInvestmentReturns').attr("data-blockid"),

        init: async () => {
            commonFundUtils.spinner.show("YieldInvestmentReturnDesktopTable");
            yieldInvestmentReturns.tableData = await commonFundUtils.getData(yieldInvestmentReturns.blockId, yieldInvestmentReturns.endpoint)
            yieldInvestmentReturns.drawTable()
            yieldInvestmentReturns.drawMobileTable()
            commonFundUtils.spinner.hide("YieldInvestmentReturnDesktopTable");
        },
        //draw the table
        drawTable: async() => {
            await commonFundUtils.drawDesktopTable(
                "veYieldInvestmentReturns",
                "YieldInvestmentReturnDesktopTable",
                yieldInvestmentReturns.tableData,
                yieldInvestmentReturns.drawHeader,
                yieldInvestmentReturns.tableData
            )
            yieldInvestmentReturns.drawBlock(yieldInvestmentReturns.tableData, yieldInvestmentReturns.tableHeaderArray, yieldInvestmentReturns.tableClassesArray, yieldInvestmentReturns.isExcelDownloading)
            yieldInvestmentReturns.enableHeaderClicks()
        },
        //used to draw the table header
        drawHeader: (dataSet) => {
            yieldInvestmentReturns.tableHeaderArray = [];
            yieldInvestmentReturns.tableClassesArray = [];
            yieldInvestmentReturns.tableTitleArray = [];
            var tableheader = '';
            tableheader = '<thead><tr><th></th><th colspan="2" style="border-bottom: 1px solid;">Month-End ' + dataSet.MonthEndDate + '</th><th colspan="3" style="border-bottom: 1px solid;">Quarter-End ' + dataSet.QuarterEndDate + '</th></tr>';
            tableheader += '<tr>'
            $.each(dataSet.MonthEndColumns, function () {
                tableheader += '<th class="table-header-item ' + this.CellClass + ' ' + commonFundUtils.getUnderlinedClass("veYieldInvestmentReturns", this.ColumnName) + '" id="' + this.ColumnName + '"><span class="table-thead d-inline-flex">' + columnHeaderNameKVP[this.Name] + commonFundUtils.sortIconMarkup + '</span></th>';
                yieldInvestmentReturns.tableHeaderArray.push(this.ColumnName);
                yieldInvestmentReturns.tableClassesArray.push(this.CellClass);
                yieldInvestmentReturns.tableTitleArray.push(columnHeaderNameKVP[this.Name])
            })
            $.each(dataSet.QuarterEndColumns, function () {
                tableheader += '<th class="table-header-item ' + this.CellClass + ' ' + commonFundUtils.getUnderlinedClass("veYieldInvestmentReturns", this.ColumnName) + '" id="' + this.ColumnName + '"><span class="table-thead d-inline-flex">' + columnHeaderNameKVP[this.Name] + commonFundUtils.sortIconMarkup + '</span></th>';
                yieldInvestmentReturns.tableHeaderArray.push(this.ColumnName);
                yieldInvestmentReturns.tableClassesArray.push(this.CellClass);
                yieldInvestmentReturns.tableTitleArray.push(columnHeaderNameKVP[this.Name])
            })
            tableheader += '</tr></thead>';
            return tableheader;
        },
        drawBlock: (dataSet, headerArray, classArray, isExcel) => {
            var tableBlock = '';
            tableBlock += '<tbody>';
            $.each(dataSet.MonthEndReturns, function (index) {
                var monthEndItem = this;
                var quarterEndItem = dataSet.QuarterEndReturns[index]
                tableBlock += '<tr>';
                tableBlock += '<td class="' + classArray[0] + '">' + monthEndItem[headerArray[0]] + '</td>'
                for (let i = 1; i < (headerArray.length / 2); i++) {
                    tableBlock += '<td class="' + classArray[i] + '">' + monthEndItem[headerArray[i]].toFixed(2)  + '</td>'
                }
                for (let j = 3; j < (headerArray.length); j++) {
                    tableBlock += '<td class="' + classArray[j] + '">' + quarterEndItem[headerArray[j]].toFixed(2) + '</td>'
                }
                tableBlock += '</tr>';
            })
            //tableBlock += commonFundUtils.drawItemsInGroup(dataSet, yieldInvestmentReturns.tableClassesArray, yieldInvestmentReturns.tableHeaderArray)
            tableBlock += '</tbody>';
            if (isExcel) {
                yieldInvestmentReturns.isExcelDownloading = false
                return tableBlock
            } else {
                $('#veYieldInvestmentReturns table').append(tableBlock);
            }
        },
        enableHeaderClicks: () => {
            $('#veYieldInvestmentReturns .table-header-item').on("click", function () {
                commonFundUtils.changeDivAttributes(this, yieldInvestmentReturns.wrapperDiv)
                yieldInvestmentReturns.tableData.MonthEndReturns = commonFundUtils.sortData(yieldInvestmentReturns.tableData.MonthEndReturns, yieldInvestmentReturns.wrapperDiv)
                yieldInvestmentReturns.tableData.QuarterEndReturns = commonFundUtils.sortData(yieldInvestmentReturns.tableData.QuarterEndReturns, yieldInvestmentReturns.wrapperDiv)
                yieldInvestmentReturns.drawTable()
            })
            //to run the excel button click event listner only once
            if (yieldInvestmentReturns.toggleEventListenersAdded) return
            //activating the "download excel" button click only once
            commonFundUtils.generateExcelTable("veYieldInvestmentReturns", yieldInvestmentReturns.drawExcelTable)
            yieldInvestmentReturns.toggleEventListenersAdded = true
        },
        drawMobileTable: () => {
            var mobileTable = '';
            mobileTable += '<div class="d-lg-none">'
                + '<div class="fund-listing-table table-mobile" id="YieldInvestmentsReturnMobileBlock">'
            mobileTable += yieldInvestmentReturns.drawMobileCardArray(yieldInvestmentReturns.tableData, 1, yieldInvestmentReturns.tableHeaderArray)
            if ($('#veYieldInvestmentReturns .table-mobile .table-footer').length == 0 && yieldInvestmentReturns.tableData.FooterText) {
                mobileTable += '<div class="table-footer mt-3">' + yieldInvestmentReturns.tableData.FooterText + '</div>';
            }
            mobileTable += '</div></div>'
            $(yieldInvestmentReturns.wrapperDiv).append(mobileTable);
        },
        drawMobileCardArray: (dataSet, headerColumns, headerArray) => {
            var mobileCard = '';
            $.each(dataSet.MonthEndReturns, function (index) {
                mobileCard += '<div class="fund-explorer-table__card">';
                //mobileCard += '<div class="fund-explorer-table__card-header row">';
                mobileCard += commonFundUtils.drawMobileHeader(this, headerColumns, headerArray)
               //mobileCard += '</div>'
                mobileCard += '<div class="row">'
                mobileCard += '<div class=" fund-explorer-table__card-body col-12"><div class="fund-explorer-table__card-column ">Month-End - ' + dataSet.MonthEndDate + '</div></div>'
                mobileCard += commonFundUtils.drawMobileItems(this, 1, dataSet.MonthEndColumns.length, headerArray, yieldInvestmentReturns.tableTitleArray)
                mobileCard += '<div class=" fund-explorer-table__card-body col-12"><div class="fund-explorer-table__card-column ">Quarter-End - ' + dataSet.QuarterEndDate + '</div></div>'
                mobileCard += commonFundUtils.drawMobileItems(dataSet.QuarterEndReturns[index], dataSet.MonthEndColumns.length, headerArray.length, headerArray, yieldInvestmentReturns.tableTitleArray)
                mobileCard += '</div>'
                mobileCard += '</div>'
            })
            return mobileCard;
        },
        drawExcelTable: (wrapperDiv) => {
            var excelTable = '';
            yieldInvestmentReturns.isExcelDownloading = true
            $('#excelDrawArea table').remove();
            excelTable += '<table class="d-none excel-table" border="1">';
            excelTable += yieldInvestmentReturns.drawHeader(yieldInvestmentReturns.tableData)
            excelTable += yieldInvestmentReturns.drawBlock(yieldInvestmentReturns.tableData, yieldInvestmentReturns.tableHeaderArray, yieldInvestmentReturns.tableClassesArray, yieldInvestmentReturns.isExcelDownloading)
            excelTable += '</table>';
            $('#excelDrawArea').append(excelTable);
            commonFundUtils.downloadExcelReport(wrapperDiv);
        }
    }
    
    //function is only initiated if the block ID is a number
    if (!isNaN(yieldInvestmentReturns.blockId)) {
        yieldInvestmentReturns.init()
    }
})